export default "__VITE_ASSET__RoaqaBKs__"